import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../../utils/apiConfig";
import { useLanguage } from "../../../context/LanguageProvider";

interface SEOProps {
    title: string;
    description: string;
    // Path after the language prefix, without a trailing slash: "", "/blog", "/course/5"
    path?: string;
    noIndex?: boolean; // Hides the page from search engines (404, admin, private pages)
}

const SEO = ({ title, description, path = "", noIndex = false }: SEOProps) => {
    const { lang } = useLanguage();

    return (
        <Helmet>
            {/* <html lang/dir> is NOT set here: LanguageProvider already owns it */}
            <title>{title}</title>
            <meta name="description" content={description} />
            {noIndex && <meta name="robots" content="noindex, nofollow" />}

            <link rel="canonical" href={`${SITE_URL}/${lang}${path}`} />

            {/* Tells search engines about the other language versions */}
            <link rel="alternate" hrefLang="fa" href={`${SITE_URL}/fa${path}`} />
            <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en${path}`} />
            <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/fa${path}`} />
        </Helmet>
    );
};

export default SEO;